var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSideCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.07816 9.28871C7.32481 9.04207 7.32481 8.64217 7.07816 8.39553C6.83151 8.14888 6.43162 8.14888 6.18497 8.39553L3.02708 11.5534C2.78043 11.8001 2.78043 12.2 3.02708 12.4466L6.18497 15.6045C6.43162 15.8511 6.83151 15.8511 7.07816 15.6045C7.32481 15.3579 7.32481 14.958 7.07816 14.7113L4.36686 12L7.07816 9.28871Z",
    fill: "#3F3F3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.15789 24H20.8421C22.5862 24 24 22.5862 24 20.8421V3.15789C24 1.41384 22.5862 0 20.8421 0H3.15789C1.41384 0 0 1.41384 0 3.15789V20.8421C0 22.5862 1.41384 24 3.15789 24ZM3.15789 1.26316C2.11146 1.26316 1.26316 2.11146 1.26316 3.15789V20.8421C1.26316 21.8885 2.11146 22.7368 3.15789 22.7368H8.84209V1.26316H3.15789ZM10.1053 1.26316V22.7368H20.8421C21.8885 22.7368 22.7368 21.8885 22.7368 20.8421V3.15789C22.7368 2.11146 21.8885 1.26316 20.8421 1.26316H10.1053Z",
    fill: "#3F3F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideCollapse);
export default __webpack_public_path__ + "static/media/sideCollapse.a0d1780f590dde4eb7c5821cadb86a45.svg";
export { ForwardRef as ReactComponent };